import React from "react";
import "./ProjectCard.css";

const ProjectCard = ({ project }) => {

  return (
    <div className="project-card-container flex flex-col md:flex-row bg-gradient-to-tr from-[#f0f4f8] to-[#e0f7fa]  rounded-3xl overflow-hidden border border-gray-200 w-full h-full font-sans">
      {/* Left Side - Image */}
      <div className="w-full md:w-2/5 h-60 md:h-auto flex items-center justify-center bg-white p-6">
        <img
          src={project.image}
          alt={project.title}
          className="w-full h-full object-contain rounded-lg  transition-transform hover:scale-105 duration-300"
        />
      </div>

      {/* Right Side - Content */}
      <div className="w-full md:w-3/5 p-8 flex flex-col justify-between">
        {/* Project Title 45% of parent div*/}
        <div className="project-card-project-title-and-tech mb-4h-2/5">
          {/* <h1 className="text-3xl md:text-4xl font-extrabold text-gray-800 tracking-tight mb-2"> */}
          <h1 className="project-card-project-title text-xl sm:text-3xl md:text-4xl font-extrabold text-gray-800 h-2.5/6 tracking-tight sm:mb-2 clamp-1-lines sm:clamp-2-lines">
            {project.title}
          </h1>
          <p className="text-gray-500 text-sm h-1/6 ">Technologies used:</p>

          {/* Tech Used */}
          <ul className="flex flex-wrap gap-3 sm:mb-6 sm:mt-4   overflow-hidden ">
            {project.tools.map((tool, index) => (
              <li
                key={index}
                className="bg-white border border-gray-300 text-gray-800 px-4 py-1 text-sm font-semibold rounded-full shadow-sm hover:bg-gray-100 transition"
              >
                {tool}
              </li>
            ))}
          </ul>
        </div>

        {/* Description */}
        <div className="text-gray-700 sm:text-md leading-relaxed  text-justify h-1.5/5">
          {/* <p>{project.description}</p> */}
          {project.description.split("\n\n").map((para, idx) => (
            <p
              key={idx}
              className={`mb-4 ${
                idx === 0 ? "clamp-4-lines-sm" : "hide-on-small"
              }`}
          
            >
              {para}
            </p>
//             <p
//   key={idx}
//   className={`mb-4 ${
//     idx === 0
//       ? "clamp-4-lines-sm clamp-4-lines-md"
//       : idx === 1
//       ? "clamp-4-lines-md hide-on-small"
//       : "hide-on-small"
//   }`}
// >
//   {para}
// </p>

          ))}
        </div>

        {/* Action Buttons */}
        <div className="flex flex-row sm:flex-wrap gap-4 sm:mt-auto md-1 h-1/5 sm:h-auto">
          <button
            onClick={() => window.open(project.liveLink, "_blank")}
            className="bg-blue-600 text-white sm:px-5 sm:py-2 rounded-xl sm:rounded-full text-sm font-semibold shadow hover:bg-blue-700 transition"
          >
            🚀 Live Project
          </button>
          <button
            onClick={() => window.open(project.sourceCodeLink, "_blank")}
            className="bg-gray-800 text-white sm:px-5 sm:py-2 rounded-xl sm:rounded-full text-sm font-semibold shadow hover:bg-gray-900 transition"
          >
            🛠️ Source Code
          </button>
          <button
            onClick={() => window.open(project.fullProject, "_blank")}
            className="bg-green-600 text-white sm:px-5 sm:py-2 rounded-xl sm:rounded-full text-sm font-semibold shadow hover:bg-green-700 transition"
          >
            📂 Full Project
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;

// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// const ProjectCard = ({ project }) => {
//     const navigate = useNavigate();
//   return (
//     <div className="project-card-container flex flex-col md:flex-row bg-gray-300 shadow-lg rounded-lg overflow-hidden border border-gray-200 w-full h-full">

//       <div className="project-card-img w-full md:w-2/5 h-1/2 md:h-full flex items-center justify-center bg-gray-700 p-6">
//         <img
//           src={project.image}
//           alt={project.title}
//           className="w-full h-full object-contain rounded-lg shadow-sm  transition-transform hover:scale-[1.02] duration-300"
//         />
//       </div>

//       <div className="project-card-body w-full md:w-3/5 h-1/2 md:h-full p-8 flex flex-col justify-between">

//         <div className="project-card-body-heading mb-6">
//           <h1 className="text-4xl font-bold text-gray-800">{project.title}</h1>
//         </div>

//         <ul className="project-card-body-tools flex flex-wrap gap-4 mb-6">
//           {project.tools.map((tool, index) => (
//             <li key={index} className="bg-gray-200 text-black-700 px-4 py-2 text-md font-medium rounded-full shadow-sm">
//               {tool}
//             </li>
//           ))}
//         </ul>

//         <div className="project-card-body-content text-gray-700 mb-6">
//           <p className="text-lg leading-relaxed">{project.description}</p>
//         </div>

//         <div className="project-card-body-buttons flex flex-wrap gap-6">
//           <button className="flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg text-lg font-medium shadow-md hover:bg-blue-700 transition"
//           onClick={() => window.open(project.liveLink, '_blank')}
//           >
//             🚀 Live Project
//           </button>
//           <button className="flex items-center gap-2 bg-gray-700 text-white px-6 py-3 rounded-lg text-lg font-medium shadow-md hover:bg-gray-800 transition">
//             🛠️ Source Code
//           </button>
//           <button className="flex items-center gap-2 bg-green-600 text-white px-6 py-3 rounded-lg text-lg font-medium shadow-md hover:bg-green-700 transition"
//           onClick={() => navigate('/project-details')}>
//             📂 Full Project
//           </button>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default ProjectCard;
